import { jwtDecode } from "jwt-decode";

export const get_token_data = () => {
  try {
    const token = sessionStorage.getItem("fd_admin_token");
    if (token) {
      const decoded = jwtDecode(token);
      return decoded;
    }
  } catch (error) {
    return null;
  }
};
